/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Tickets_Updated_ColInputs */

const en_admin_tickets_updated_col = /** @type {(inputs: Admin_Tickets_Updated_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last Updated`)
};

/**
* | output |
* | --- |
* | "Last Updated" |
*
* @param {Admin_Tickets_Updated_ColInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_tickets_updated_col = /** @type {((inputs?: Admin_Tickets_Updated_ColInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Tickets_Updated_ColInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_tickets_updated_col(inputs)
});
export { admin_tickets_updated_col as "admin.tickets.updated_col" }